export default {
  // 实例列表
  'knowledge.instance.title': '知识库',
  'knowledge.instance.list.create': '创建实例',
  'knowledge.instance.list.columns.name': '名称',
  'knowledge.instance.list.columns.description': '描述',
  'knowledge.instance.list.columns.status': '状态',
  'knowledge.instance.list.columns.plan': '规格',
  'knowledge.instance.list.columns.clusterType': '集群类型',
  'knowledge.instance.list.columns.computeUnit': '计算单元',
  'knowledge.instance.list.columns.region': '区域',
  'knowledge.instance.list.columns.availabilityMode': '可用模式',
  'knowledge.instance.list.columns.flavor': '规格型号',
  'knowledge.instance.list.columns.creationTime': '创建时间',
  'knowledge.instance.list.columns.actions': '操作',
  'knowledge.instance.list.actions.manage': '管理',
  'knowledge.instance.list.actions.delete': '删除',
  'knowledge.instance.list.empty': '暂无知识库',
  'knowledge.instance.delete.success': '删除成功',
  'knowledge.instance.delete.confirmContent': '确认删除该实例吗？',
  // 实例详情
  'knowledge.instance.detail.kbList': '知识库列表',
  // 创建实例
  'knowledge.instance.create.title': '创建实例',
  'knowledge.instance.create.name': '名称',
  'knowledge.instance.create.nameRequired': '请输入名称',
  'knowledge.instance.create.namePlaceholder': '请输入实例名称',
  'knowledge.instance.create.description': '描述',
  'knowledge.instance.create.descriptionPlaceholder': '请输入描述',
  'knowledge.instance.create.region': '区域',
  'knowledge.instance.create.regionRequired': '请选择区域',
  'knowledge.instance.create.plan': '规格',
  'knowledge.instance.create.planRequired': '请选择规格',
  'knowledge.instance.create.availabilityMode': '可用性模式',
  'knowledge.instance.create.availabilityModeRequired': '请选择可用性模式',
  'knowledge.instance.create.modeSingle': '单节点',
  'knowledge.instance.create.modeSingleDesc':
    '单机部署，适合开发与测试场景，成本较低',
  'knowledge.instance.create.modeMulti': '高可用',
  'knowledge.instance.create.modeMultiDesc':
    '集群部署，提供高可用保障，适合生产环境',
  'knowledge.instance.create.flavor': '配置规格',
  'knowledge.instance.create.flavorRequired': '请选择配置规格',
  'knowledge.instance.create.planBasicDesc': '基础版描述',
  'knowledge.instance.create.planProductionDesc': '生产版描述',
  'knowledge.instance.create.clusterType': '集群类型',
  'knowledge.instance.create.clusterTypeRequired': '请选择集群类型',
  'knowledge.instance.create.typeBalancedDesc': '均衡型描述',
  'knowledge.instance.create.typeQueryDesc': '查询型描述',
  'knowledge.instance.create.typeWriteDesc': '写入型描述',
  'knowledge.instance.create.computeUnit': '计算单元',
  'knowledge.instance.create.computeUnitRequired': '请选择计算单元',
  'knowledge.instance.create.computeUnitDesc': '计算单元说明',
  'knowledge.instance.create.storage': '存储',
  'knowledge.instance.create.storageRequired': '请选择存储',
  'knowledge.instance.create.success': '创建成功',
  'knowledge.instance.create.fail': '创建失败',
  // 文档
  'knowledge.document.chunks': '文档分块',
  'knowledge.document.chunkList': '分块列表',
  'knowledge.document.original': '原文',
  'knowledge.document.list.title': '文档列表',
  'knowledge.document.list.columns.name': '名称',
  'knowledge.document.list.columns.status': '状态',
  'knowledge.document.list.columns.enabled': '已启用',
  'knowledge.document.list.columns.disabled': '已禁用',
  'knowledge.document.list.columns.createdAt': '创建时间',
  'knowledge.document.list.columns.actions': '操作',
  'knowledge.document.list.actions.delete': '删除',
  'knowledge.document.delete.confirm': '确认删除该文档吗？',
  'knowledge.document.delete.success': '文档已删除',
  'knowledge.document.add': '添加文档',
  'knowledge.document.add.title': '添加文档',
  'knowledge.document.add.file': '文件',
  'knowledge.document.add.fileRequired': '请选择要上传的文件',
  'knowledge.document.add.selectedFile': '已选文件',
  'knowledge.document.add.success': '添加成功',
  // 文档详情（分块 / 原文）
  'knowledge.document.chunk.add': '添加分块',
  'knowledge.document.chunk.sort': '序号',
  'knowledge.document.chunk.content': '内容',
  'knowledge.document.chunk.actions': '操作',
  'knowledge.document.chunk.edit': '编辑',
  'knowledge.document.chunk.delete': '删除',
  'knowledge.document.chunk.deleteConfirm': '确认删除该分块？',
  'knowledge.document.chunk.modal.editTitle': '编辑分块',
  'knowledge.document.chunk.modal.addTitle': '添加分块',
  'knowledge.document.chunk.modal.contentLabel': '内容',
  'knowledge.document.chunk.modal.questionsLabel': '问题',
  'knowledge.document.chunk.modal.importantKeywordsLabel': '重要关键词',
  'knowledge.document.chunk.modal.tagPlaceholder': '输入后回车添加',
  'knowledge.document.chunk.updated': '分块已更新',
  'knowledge.document.chunk.created': '分块已创建',
  'knowledge.document.chunk.deleted': '分块已删除',
  'knowledge.document.original.binaryTip':
    '该文档为二进制格式（如 Word/PDF），无法直接预览，可下载后查看。',
  'knowledge.document.original.downloadBtn': '下载原文（{fileName}）',
  'knowledge.document.original.fileLabel': '文件',
  'knowledge.document.original.loading': '加载中或为空...',
  'knowledge.document.original.downloadStart': '下载已开始',
  'knowledge.document.original.downloadFailed': '下载失败',
  'knowledge.document.original.notReady': '文档尚未解析完成，无法下载',
  'knowledge.document.original.statusTip.UNSTART': '文档尚未开始解析',
  'knowledge.document.original.statusTip.RUNNING': '文档正在解析中，请稍候...',
  'knowledge.document.original.statusTip.FAIL': '文档解析失败，无法查看原文',
  'knowledge.document.original.statusTip.CANCEL': '文档解析已取消',
  // 知识库
  'knowledge.kb.create': '创建知识库',
  'knowledge.kb.create.title': '创建知识库',
  'knowledge.kb.update.title': '编辑知识库',
  'knowledge.kb.create.name': '名称',
  'knowledge.kb.create.nameRequired': '请输入名称',
  'knowledge.kb.create.namePlaceholder': '请输入知识库名称',
  'knowledge.kb.create.description': '描述',
  'knowledge.kb.create.descriptionPlaceholder': '请输入描述',
  'knowledge.kb.create.settings': '配置',
  'knowledge.kb.create.embeddingModel': '嵌入模型',
  'knowledge.kb.create.embeddingModelRequired': '请选择嵌入模型',
  'knowledge.kb.create.embeddingModelPlaceholder': '请选择嵌入模型',
  'knowledge.kb.create.loadModelsFailed': '加载模型列表失败',
  'knowledge.kb.create.success': '创建成功',
  'knowledge.kb.update.success': '更新成功',
  'knowledge.kb.list.columns.name': '名称',
  'knowledge.kb.list.columns.description': '描述',
  'knowledge.kb.list.columns.docCount': '文档数',
  'knowledge.kb.list.columns.linkedWorkflows': '关联工作流',
  'knowledge.kb.list.columns.updatedAt': '更新时间',
  'knowledge.kb.list.columns.actions': '操作',
  'knowledge.kb.list.actions.edit': '编辑',
  'knowledge.kb.list.actions.delete': '删除',
  'knowledge.kb.list.error.fetchFailed': '获取知识库列表失败',
  'knowledge.kb.delete.confirm': '确认删除该知识库吗？',
  'knowledge.kb.delete.confirmTitle': '确认删除',
  'knowledge.kb.delete.confirmContent':
    '确定要删除知识库「{name}」吗？此操作不可恢复。',
  'knowledge.kb.delete.success': '删除成功',
  'knowledge.instance.selectPlaceholder': '选择实例',
  'knowledge.instance.label': '知识库实例',
  'knowledge.instance.selectRequired': '请先选择一个实例',
  'knowledge.kb.searchPlaceholder': '搜索',
  'knowledge.kb.list.columns.knowledge': '知识库',
  'knowledge.kb.list.columns.documents': '文档',
  'knowledge.kb.list.columns.resource': '资源',
  'knowledge.kb.list.columns.creationTime': '创建时间',
  'knowledge.kb.list.meta.updated': '更新于 {time}',
  'knowledge.kb.menu.files': '文件',
  'knowledge.kb.menu.metadata': '元数据',
  'knowledge.kb.menu.retrievalTesting': '检索测试',
  'knowledge.kb.menu.configuration': '配置',
  'knowledge.kb.files.title': '文件',
  'knowledge.kb.files.filter.allStatus': '所有状态',
  'knowledge.kb.files.sort.uploadTime': '按上传时间排序',
  'knowledge.kb.files.searchPlaceholder': '搜索',
  'knowledge.kb.files.addFile': '添加文件',
  'knowledge.kb.files.columns.name': '名称',
  'knowledge.kb.files.columns.status': '状态',
  'knowledge.kb.files.columns.enabled': '启用',
  'knowledge.kb.files.columns.chunkNumber': '分块数',
  'knowledge.kb.files.columns.size': '大小',
  'knowledge.kb.files.columns.type': '类型',
  'knowledge.kb.files.columns.updatedAt': '更新时间',
  'knowledge.kb.files.columns.uploadTime': '上传时间',
  'knowledge.kb.files.columns.action': '操作',
  'knowledge.kb.files.action.edit': '编辑',
  'knowledge.kb.files.action.download': '下载',
  'knowledge.kb.files.action.delete': '删除',
  // Metadata
  'knowledge.metadata.title': '元数据',
  'knowledge.metadata.add': '添加元数据',
  'knowledge.metadata.filter.allStatus': '所有状态',
  'knowledge.metadata.sort.uploadTime': '按上传时间排序',
  'knowledge.metadata.searchPlaceholder': '搜索',
  'knowledge.metadata.columns.name': '名称',
  'knowledge.metadata.columns.type': '类型',
  'knowledge.metadata.columns.source': '来源',
  'knowledge.metadata.columns.values': '值数量',
  'knowledge.metadata.columns.linkedChunks': '关联分块数',
  'knowledge.metadata.columns.enabled': '启用',
  'knowledge.metadata.columns.creationTime': '创建时间',
  'knowledge.metadata.columns.action': '操作',
  'knowledge.metadata.modal.addTitle': '添加元数据',
  'knowledge.metadata.modal.editTitle': '编辑元数据',
  'knowledge.metadata.modal.name': '元数据名称',
  'knowledge.metadata.modal.nameRequired': '请输入元数据名称',
  'knowledge.metadata.modal.namePlaceholder': '请输入元数据名称',
  'knowledge.metadata.modal.nameTip':
    '元数据名称只能包含小写字母、数字和下划线，且必须以小写字母开头。',
  'knowledge.metadata.modal.type': '元数据类型',
  'knowledge.metadata.modal.typeRequired': '请选择元数据类型',
  'knowledge.metadata.delete.confirm': '确认删除该元数据吗？',
  'knowledge.metadata.delete.success': '元数据删除成功',
  // Document Detail
  'knowledge.document.chunkNumber': '分块数',
  'knowledge.document.size': '大小',
  'knowledge.document.uploadTime': '上传时间',
  'knowledge.document.sourceText': '源文本',
  'knowledge.document.searchChunks': '搜索',
  'knowledge.document.parseChunk': '解析',
  'knowledge.document.stopParseChunk': '停止解析',
  'knowledge.document.parseChunk.success': '开始解析',
  'knowledge.document.stopParseChunk.success': '停止解析',
  'knowledge.document.addChunk': '添加分块',
  'knowledge.document.retrievalSignals': '检索信号',
  'knowledge.document.metadata': '元数据',
  'knowledge.document.metadataDesc':
    '元数据作为关键过滤器，可增强信息检索的准确性和相关性。您可以在此处修改和添加此分块的元数据。',
  'knowledge.document.startLabeling': '开始标注',
  'knowledge.document.keywords': '关键词',
  'knowledge.document.keywords.addTag': '添加关键词',
  'knowledge.document.selectChunkTip': '选择一个分块以查看/编辑关键词',
  'knowledge.document.selectAll': '全选',
  'knowledge.document.enable': '启用',
  'knowledge.document.disable': '禁用',
  'knowledge.document.delete': '删除',
  'knowledge.document.status.unstart': '未开始',
  'knowledge.document.status.running': '运行中',
  'knowledge.document.status.cancel': '取消',
  'knowledge.document.status.done': '完成',
  'knowledge.document.status.fail': '失败',
  // 切片配置
  'knowledge.chunking.strategy': '切片策略',
  'knowledge.chunking.strategy.delimiter': '标识符切分',
  'knowledge.chunking.strategy.regex': '正则切分',
  'knowledge.chunking.strategy.fixed_length': '固定长度切分',
  'knowledge.chunking.strategy.by_row': '按行切分',
  'knowledge.chunking.delimiter': '分隔符',
  'knowledge.chunking.regexPattern': '正则表达式',
  'knowledge.chunking.regexPatternRequired': '请输入正则表达式',
  'knowledge.chunking.regexPatternPlaceholder': '例如：[。？！]',
  'knowledge.chunking.chunkSize': '切片大小',
  'knowledge.chunking.chunkOverlap': '重叠长度',
  'knowledge.chunking.lengthUnit': '计量单位',
  'knowledge.chunking.lengthUnit.character': '字符',
  'knowledge.chunking.lengthUnit.token': 'Token',
  'knowledge.chunking.byRowDesc':
    '按行切分，适用于表格文档（.xlsx/.xls/.csv/.json/.jsonl）',
  'knowledge.document.reparse.title': '重新解析',
  'knowledge.document.reparse.success': '解析任务已提交，请稍后刷新查看状态',
  'knowledge.document.add.asyncTip':
    '文档已上传，正在解析中，请稍后刷新查看状态',
  // 检索测试
  'knowledge.retrieval.title': '检索测试',
  'knowledge.retrieval.desc': '基于给定的查询文本测试知识库的命中效果。',
  'knowledge.retrieval.setting.title': '检索设置',
  'knowledge.retrieval.strategy.vector': '语义检索',
  'knowledge.retrieval.strategy.vectorDesc':
    '生成查询嵌入，并搜索与其向量表示最相似的文本块。',
  'knowledge.retrieval.strategy.fullText': '全文检索',
  'knowledge.retrieval.strategy.fullTextDesc':
    '索引文档中的所有术语，允许用户搜索任何术语并检索包含这些术语的相关文本块。',
  'knowledge.retrieval.strategy.hybrid': '混合检索',
  'knowledge.retrieval.strategy.hybridDesc':
    '同时执行全文检索和向量检索，重新排序以选择用户查询的最佳匹配。',
  'knowledge.retrieval.setting.scoreThreshold': '匹配分',
  'knowledge.retrieval.setting.rerank': '重排序配置',
  'knowledge.retrieval.setting.rerankPlaceholder': '请选择一个重排序模型',
  'knowledge.retrieval.setting.weightedScore': '权重设置',
  'knowledge.retrieval.setting.semantic': '语义',
  'knowledge.retrieval.setting.keyword': '关键词',
  'knowledge.retrieval.setting.topK': '召回数量 (Top K)',
  'knowledge.retrieval.setting.query': '查询文本',
  'knowledge.retrieval.setting.queryPlaceholder': '请输入用于测试的查询文本',
  'knowledge.retrieval.result.title': '测试结果 ({count})',
  'knowledge.retrieval.result.empty': '尚未运行测试，结果将显示在这里。',
  'knowledge.retrieval.result.noData': '未找到相关结果。',
  'knowledge.retrieval.error.queryRequired': '请输入查询文本',
  'knowledge.retrieval.error.rerankRequired': '请选择重排序模型',
  'knowledge.retrieval.error.testFailed': '检索测试失败',
};
